/**
 * Shipment list widget component
 * Author: sandeep.yadav@hp.com
 * Date: July  2020
 */

import React, { useState, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

import { fmDate } from './formatter.jsx';
import { getPackingListLink } from "../widget/widget.svc.js";

import Truck_Veneer from '../assets/images/truck_round_filled.svg';
import Bill_RGB_gray_NT from '../assets/images/Bill_RGB_gray_NT.png';
import Shipping_RGB_blue_NT from '../assets/images/Shipping_RGB_blue_NT.png';
import Bill_RGB_green_NT from '../assets/images/Bill_RGB_green_NT.png';
import train_icon from '../assets/images/train_icon.png';
import train_icon_trans from '../assets/images/train_icon_trans.png';
import airplane from '../assets/images/airplane.png';
import airplane_trans from '../assets/images/airplane_trans.png';
import vessel from '../assets/images/vessel.png';
import vessel_trans from '../assets/images/vessel_trans.png';
import Shipping_RGB_grey_NT from '../assets/images/Shipping_RGB_grey_NT.png';
import train_icon_grey from '../assets/images/train_icon_grey.png';
import airplane_grey from '../assets/images/airplane_grey.png';
import vessel_grey from '../assets/images/vessel_grey.png';
import house_gray from '../assets/images/house_gray.png';
import house_green from '../assets/images/house_green.png';
import house_can from '../assets/images/house_can.png';
import blue_arrow_right_line from '../assets/images/blue_arrow_right_line.png';
import blue_arrow_right_end from '../assets/images/blue_arrow_right_end.png';
import gray_arrow_right_line from '../assets/images/gray_arrow_right_line.png';
import xdock_blue from '../assets/images/xDockBlue.png';
import xdock_green from '../assets/images/xDockGreen.png';
import factory from '../assets/images/factory.png';
import gray_arrow_right_end from '../assets/images/gray_arrow_right_end.png';

import "../assets/css/shipment-list-widget.css"
import { sanitizeUrl } from "./utils.js";

const cssGray  = "invert(80%) sepia(0%)   saturate(2781%) hue-rotate(59deg)  brightness(104%) contrast(88%)" ; //#9b9b9b
const cssBlue  = "invert(45%) sepia(100%) saturate(2144%) hue-rotate(168deg) brightness(90%)  contrast(103%)"; //#0096d6
const cssGreen = "invert(20%) sepia(96%)  saturate(2425%) hue-rotate(135deg) brightness(98%)  contrast(101%)"; //#008424

const useToggle = (initialState = false) => {
  const [state, setState] = useState(initialState);
  const toggle = useCallback(() => setState(state => !state), []);
  return [state, toggle]
}

const ToggleTable = (props) => {
  const { columns, callerArea } = props;
  const [showAll, setShowAll] = useToggle();

  //below columns are defined in DataServiceConfig and are a result of string_agg() function
  var columnsToRender = ["ship_trk_item_no", "ship_trk_product", "ship_trk_product_descr", "ship_trk_shipped_qty"]

  // Use this until data dictionary works
  //var columnsToRender = ["Item", "Product", "Description", "Qty"]

  var item_no       = columns.item_no.split(" ");
  var product       = columns.product.split(" ");
  var product_descr = columns.product_descr.split("@");
  var shipped_qty   = columns.shipped_qty.split(" ");

  // dirty workaround to have correct DD area behaviour
  // DD should be re-designed to make such things unnecessary 
  var ddArea;
  if ( callerArea == "internal") {
    ddArea = "int_widget";
  } else if (callerArea == "public" || callerArea == "external") {
    ddArea = "ext_widget";
  } else {
    ddArea = "osv";
  }

  var headers = columnsToRender.map((column, i) => {
    return <th key={i} style={{ "textAlign": "center" }}><span>{T(DD(column, ddArea).dd_label)}</span></th>;
  })

  var values = item_no.map((value, i) => {
    return <tr>
              <td style={{ "textAlign": "center", "whiteSpace": "pre-wrap" }}>{item_no[i]}</td>
              <td style={{ "textAlign": "center", "whiteSpace": "pre-wrap" }}>{product[i]}</td>
              <td style={{ "textAlign": "center", "whiteSpace": "pre-wrap" }}>{product_descr[i]}</td>
              <td style={{ "textAlign": "center", "whiteSpace": "pre-wrap" }}>{shipped_qty[i]}</td>
           </tr>
  })

  var allRS = values.length;
  var recordsets = 0;
  if (!showAll) {
    values = values[0];
    recordsets = 1;
  } else {
    recordsets = values.length;
  }

  return (
    <div style={{ "width": "100%" }}>
      <div style={{ "width": "100%", "display":"flex", "justifyContent":"space-between" }} className="sdg-topbar" onClick={setShowAll}>
        <div>
          <i title="Expand/Collapse" className={showAll ? "glyphicon glyphicon-chevron-up" : "glyphicon glyphicon-chevron-down"} style={{"cursor":"pointer", "margin":"2px"}}/>
        </div> 
        <div>
          <span>Showing {recordsets} out of {allRS} item(s)</span>
        </div>
      </div>
      <table className="table tablelight" style={{ "marginBottom": "0px" }}>
        <thead>
          <tr>
            {headers}
          </tr>
        </thead>
        <tbody>
          {values}
        </tbody>
      </table>
  </div>
  );
};

export class ShipmentListWidget extends React.Component {

  constructor(props) {
    super(props);
    this.tblRef = React.createRef();
    this.downloadPackingList = this.downloadPackingList.bind(this);

    this.state = {
      packingDownloading: false,
    };
  }

  componentDidMount() {
    var c = this.tblRef.current;
    var self = this;

    if (self.props.stretchTo) {
      var sTo = document.querySelectorAll(self.props.stretchTo)[0];
      var sToRect = sTo.getBoundingClientRect();
      var clrect = c.getBoundingClientRect(); 
      var smargin = 1;
      if (self.props.stretchMargin) { 
          smargin = parseInt(self.props.stretchMargin);
      }
      c.style.height = (sToRect.top - clrect.top - smargin)  + 'px';
  }

    window.addEventListener('resize', function () {
      //console.log('window resize detected');
      if (self.props.stretchTo) {
          var sTo = document.querySelectorAll(self.props.stretchTo)[0];
          var sToRect = sTo.getBoundingClientRect();
          var clrect = c.getBoundingClientRect(); 
          var smargin = 1;
          if (self.props.stretchMargin) { 
              smargin = parseInt(self.props.stretchMargin);
          }
          c.style.height = (sToRect.top - clrect.top - smargin)  + 'px';
      }
      setTimeout( function() {
          self.adjustHeader(c,-1);
      }, 330);
    });
  } 

  checkValidXDockDate(xdock_date) {
    if (xdock_date == "") {
      xdock_date = "n/a";
    } else {
      xdock_date = fmDate(xdock_date);
    }
    return xdock_date;
  }

  xDockDateToolTip(xdock_reg_date, xdock_dep_date) {
    return 'xDock Registration: ' + this.checkValidXDockDate(xdock_reg_date) + ' | xDock Departure: ' + this.checkValidXDockDate(xdock_dep_date);
  }

  handleSinglePackListDL(res) {
    const packingListDownloadLink = RewriteRESTURL("/os/ws/osvHelper.tcl" + res.url);
    window.open(packingListDownloadLink, "downloadwindow", "menubar=1,resizable=1,width=750,height=590");
  }

  downloadPackingList(legacy_order_no, shipment_no, hpdeliveryno, callerArea, aaid) {

  if (!this.state.packingDownloading) {

    this.setState({
      packingDownloading: true
    })
    toast.info('Packing list download triggered',{
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    getPackingListLink(legacy_order_no, shipment_no, hpdeliveryno, callerArea, (res) => {
      if (res.status === 'S') {
        const found = window.location.origin.match("orderstatus");
        var packingListURL;
        if(found) {
          packingListURL = window.location.origin + '/sso/os/extws/extUIHelper.tcl' + res.url + '&aaid=' + aaid;
        } else {
          packingListURL = window.location.origin + '/os/ws/osvHelper.tcl' + res.url;
        }
        var sanitizeURL = sanitizeUrl(packingListURL);
        axios.get(sanitizeURL, {
          responseType: 'blob',
        }).then((response) => {
          this.setState({
            packingDownloading: false
          })

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          if (response.headers['content-type'] === "application/pdf") {
            link.setAttribute('download', 'Packing_list-' + shipment_no + '.pdf');
            link.click();
          } else {
            toast.warn('Packing list not available.', {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
      } else {
        this.setState({
          packingDownloading: false
        })
      }
    });
  }
  }

  render() {

    var OMSystem = this.props.OMSystem;
    var handlePodImage = this.props.handlePodImage;
    var TATPreURL = this.props.TATPreURL;
    var aaid = this.props.orderAAID;

    var callerArea = "internal";
    if (this.props.callerArea) {
      callerArea = this.props.callerArea;
    }
    var self = this;
    var shipments = this.props.shipmentList.map(function (row, i) {

      if (row.ignore) return <noscript />;

      var podImgCol = "";

      if (1 || OMSystem === "SAP-R01" || OMSystem === "SAP-CPO" || OMSystem === "SAPCPO" || OMSystem === "SAPCPO") {

        if (row.shipped_at != "" && callerArea != "public") {
          //TODO, create security clause to make those calls possible also from external (orderstatus)
          var packListImg = 
            <a title='download Packing List' style={{ "padding": "3px", cursor:"pointer" }}
              onClick={() => self.downloadPackingList(row.legacy_order_no, row.shipmentno, row.hpdeliveryno, callerArea, aaid)}>
              <img height="18" src={Bill_RGB_green_NT} />
            </a>;
        } else {
          var packListImg = <img height="16" src={Bill_RGB_gray_NT} />;
        }

        if (row.pod_at != "" && callerArea != "public") {
          var podImg = <a title='download or view POD scan image' style={{ "padding": "3px", cursor:"pointer" }}
            onClick={(function (a, event) { handlePodImage(row.legacy_order_no, row.shipmentno, row.carriername, row.trackingno, row.hpdeliveryno, TATPreURL) }).bind(this)}>
            <img height="18" src={Bill_RGB_green_NT} />
          </a>;
        } else {
          var podImg = <img height="16" src={Bill_RGB_gray_NT} />;
        }

        podImgCol = <td style={{ "textAlign": "center" }}>{podImg}</td>;
      }

      var tNTButton = <span>{row.trackingno}</span>;
      var TNTUrl = null;
      if (row.tnt_url && row.tnt_url != "" && callerArea != "public") {
        var hurl = row.tnt_url.split("")
                   .map(c => c.charCodeAt(0).toString(16).padStart(2, "0"))
                   .join("");

        var ssoPrefix = '';
        console.log('TNT: window.location.host=',
                    window.location.host,
                    window.location.host.match(/orderstatus/)
        );
        if (window.location.host.match(/orderstatus/)) {
            ssoPrefix = '/sso';
        } 
        console.log(ssoPrefix);

        var TNTUrl = `${ssoPrefix}/os/ws/osvHelper?shipment=${row.shipmentno}&order=${row.legacy_order_no}&tracktracepunchout=${hurl}`
        tNTButton =
          <a type="button" className="btn btn-primary btn-smallest" href={TNTUrl} target='OSSTandT'>
            <i className="glyphicon glyphicon-new-window" />&nbsp;<span>{row.trackingno}</span>
          </a>;
      }

      var trackYourShipmentBtn = null;
      var shipmentCancelled = false;

      var realDeliveryDate = ""
      if (row.pod_at != "") {
        realDeliveryDate = row.pod_at;
      } else if (row.pod_actual != "") {
        realDeliveryDate = row.pod_actual;
      } else if (row.deliverydate != "") {
        realDeliveryDate = row.deliverydate;
      }

      if (row.ship_cancelled_at != "") {
        const shipCancelledDate_Obj = new Date(row.ship_cancelled_at);
        const realDeliveryDate_Obj  = new Date(realDeliveryDate);

        if (realDeliveryDate_Obj == "Invalid Date" || (realDeliveryDate_Obj != "Invalid Date" && shipCancelledDate_Obj.getTime() > realDeliveryDate_Obj.getTime())) {
          shipmentCancelled = true;
        }
      }

      if (!shipmentCancelled) {

        if (row.tnt_url && row.tnt_url != "" && callerArea != "public" ) {
          trackYourShipmentBtn = <a type="button" style={{ "float": "right" }} className="btn btn-primary btn-smallest" href={TNTUrl} target='OSSTandT'>
            <i className="glyphicon glyphicon-new-window" />&nbsp;<span>{T("TrackYourShipment")}</span>
          </a>;
        }

        if ((row.pod_at != "" || row.deliverydate != "") && callerArea != "public") {
          trackYourShipmentBtn = <a type="button" style={{ "float": "right" }} className="btn btn-primary btn-smallest"
            onClick={(function (a, event) { handlePodImage(row.legacy_order_no, row.shipmentno, row.carriername, row.trackingno, row.hpdeliveryno, TATPreURL) }).bind(this)}>
            <i className="glyphicon glyphicon-download-alt" />&nbsp;<span>{T("ShowShipmentPOD")}</span>
          </a>;
        }
      }

      if (row.ship_to_addr_6 == "") {
        var ShipAddr = <span>{row.ship_to_addr_5}, {row.ship_to_country_code}</span>
      } else {
        var ShipAddr = <span>{row.ship_to_addr_5} {row.ship_to_addr_6}, {row.ship_to_country_code}</span>
      }

      var House = house_gray;

      var sched_delv_date_color = "#888"

      var sched_delv_date = new Date(row.sched_delv_date);
      var now = new Date();
      if (now.getTime() > sched_delv_date.getTime()) {
        sched_delv_date_color = "orange";
      }
      
      var DDateLabel = <span style={{ "color": sched_delv_date_color }}>Planned Delivery</span>;
      var DDateValue = <span style={{ "color": sched_delv_date_color }}>{fmDate(row.sched_delv_date)}</span>;

      if (realDeliveryDate != "") {
        DDateLabel = <span style={{ "color": "green" }}>Delivery Date</span>;
        DDateValue = <span style={{ "color": "green" }}>{fmDate(realDeliveryDate)} {podImg}</span>;
        House = house_green;
      }

      var CommentLine = "";
      if (row.sdd_comment != "") {
        CommentLine = <span>{('Comment')}: {(row.sdd_comment)}</span>;
      }

      if ( shipmentCancelled ) {
          House = house_can;
          DDateLabel = <span style={{ "textDecoration" : "line-through", "color" : "grey" }}>Planned Delivery</span>;
          DDateValue = <span style={{ "textDecoration" : "line-through", "color" : "grey" }}>{fmDate(row.sched_delv_date)}</span>;
      }

      var leg1line = blue_arrow_right_line;
      var leg1end = blue_arrow_right_end;

      var leg2line = gray_arrow_right_line;
      var leg2end = gray_arrow_right_end;

      if (row.deliverydate != "" || row.pod_at != "") {
        var leg2line = blue_arrow_right_line;
        var leg2end = blue_arrow_right_end;
      }

      var item_no = row.item_no.replace(/ /g, "\n");
      var product = row.product.replace(/ /g, "\n");

      var product_descr = row.product_descr.replace(/@/g, "\n");
      var shipped_qty = row.shipped_qty.replace(/ /g, "\n");

      var headerRow =
        <tr>
          <th style={{ "textAlign": "center" }}><span>Item</span></th>
          <th style={{ "textAlign": "center" }}><span>Product</span></th>
          <th style={{ "textAlign": "center" }}><span>Description</span></th>
          <th style={{ "textAlign": "center" }}><span>Qty</span></th>
        </tr>;

      var prodRow =
        <tr>
          <td style={{ "textAlign": "center", "whiteSpace": "pre-wrap" }}>{item_no}</td>
          <td style={{ "textAlign": "center", "whiteSpace": "pre-wrap" }}>{product}</td>
          <td style={{ "textAlign": "center", "whiteSpace": "pre-wrap" }}>{product_descr}</td>
          <td style={{ "textAlign": "center", "whiteSpace": "pre-wrap" }}>{shipped_qty}</td>
        </tr>;

      if (row.routeDetails.firstShippingType != "" && row.routeDetails.firstShippingType != "?") {
        var leg1shippingType = ShpTypeIcon(row.routeDetails.firstShippingType, shipmentCancelled);
      } else {
        var leg1shippingType = ShpTypeIcon(row.routeDetails.mainShippingType, shipmentCancelled);
      }
      if (row.routeDetails.lastShippingType != "" && row.routeDetails.lastShippingType != "?") {
        var leg2shippingType = ShpTypeIcon(row.routeDetails.lastShippingType, shipmentCancelled);
      } else {
        var leg2shippingType = ShpTypeIcon(row.routeDetails.mainShippingType, shipmentCancelled);
      }

      var firstCarrier = row.carriername;
      if (row.routeDetails.firstCarrier && row.routeDetails.firstCarrier != "") {
        firstCarrier = row.routeDetails.firstCarrier;
      }
      var lastCarrier = row.carriername;
      if (row.routeDetails.lastCarrier && row.routeDetails.lastCarrier != "") {
        lastCarrier = row.routeDetails.lastCarrier;
      }

      if (lastCarrier == "UNKNOWN") {
        lastCarrier = "";
      }

      var carrierEventDescr = "";
      if (row.carrier_status_comment !== "" && row.latest_event_datetime !== "") {
        carrierEventDescr = row.carrier_status_comment +  " on " + fmDate(row.latest_event_datetime)
      }
      
      if (realDeliveryDate != "" ) {
        carrierEventDescr = "Delivered on " + fmDate(realDeliveryDate);
        row.latest_event_datetime = realDeliveryDate;
      }

      if (row.shipped_at != "" && row.latest_event_datetime == "" || row.shipped_at == row.latest_event_datetime) {
        carrierEventDescr = "Shipped on " + fmDate(row.shipped_at);
        row.latest_event_datetime = row.shipped_at;
      }

      if (shipmentCancelled) {
        carrierEventDescr = "Shipment Canceled on " + fmDate(row.ship_cancelled_at);
        row.latest_event_datetime = row.ship_cancelled_at;
      }

      var routeInformations = <td style={{ "textAlign": "left", "width": "58%", "backgroundColor": "#f2f2f2", "paddingLeft": "4px" }}>&nbsp;Route: {row.route} ({row.ftt} days) &nbsp;&nbsp; {CommentLine} </td>
      if (callerArea == "public" || callerArea == "external") {
        routeInformations = <td>{CommentLine}</td>;
      }


      var progress                  = Math.round(row.progress * 100);
      var xDockInProgressAt         = Math.round(row.xDockRegProgress * 100);
      var xDockDepProgressAt        = Math.round(row.xDockDepProgress * 100);
      var xDockProgressAtPercent;

      var latestCarrierEventDate = fmDate(row.latest_event_datetime);

      var eventDateDisplay = "inline-block";
      if (row.latest_event_datetime.slice(0,10) == row.shipped_at.slice(0,10) ) {
        eventDateDisplay = "none";
      } else if ( row.latest_event_datetime.slice(0,10) == realDeliveryDate.slice(0,10)) {
        eventDateDisplay = "none";
      }

      var progressBarElementsDisplay = "inline-block";
      if (shipmentCancelled) {
        progressBarElementsDisplay = "none";
        eventDateDisplay = "none";
      }
      var progressBarMOTElementDisplay = progressBarElementsDisplay;

      if (progress < 5) {
          latestCarrierEventDate = '';
      }

      var showLatestCarrier = (progress <  20) ? false : true;

      var progressPercent = progress  + '%'; // for width css property

      var xdockImage = xdock_blue;
      var xDockToolTip = 'No Dates Yet';
      var legNo;

      if (row.multi_leg == "Y" && callerArea == "osv") {

        var xDockInDateObj  = new Date(row.xdock_reg_date);
        var xDockOutDateObj = new Date(row.xdock_dep_date);

        if (xDockInDateObj.getTime() > xDockOutDateObj.getTime()) {
          row.xdock_dep_date = "";
        }

        var legIcon;
        if (row.xdock_dep_date != "") {
          //xdock out event, we dont care if xdock in exists.
          xdockImage = xdock_green;
          if (progress - xDockDepProgressAt <= Math.abs(5) ) {
            progressBarMOTElementDisplay = "none";
          }
          xDockProgressAtPercent  = xDockDepProgressAt  + '%';
          xDockToolTip = self.xDockDateToolTip(row.xdock_reg_date, row.xdock_dep_date);
          legNo = leg2shippingType;
        } else if (row.xdock_reg_date != "") {
          //xdock in event, without xdock out
          xdockImage = xdock_blue;
          if (progress - xDockInProgressAt <= Math.abs(5) ) {
            progressBarMOTElementDisplay = "none";
          }
          xDockProgressAtPercent  = xDockInProgressAt  + '%';
          xDockToolTip = self.xDockDateToolTip(row.xdock_reg_date, row.xdock_dep_date);
          legNo = leg1shippingType;
        } else {
          //in transit to xDock
          xDockProgressAtPercent  = 10 + progress  + '%';
          xDockToolTip = 'No Dates Yet';
          legNo = leg1shippingType;
        }

        legIcon =
        <tr className="ltIcons">
          <td rowSpan="2" style={{ "verticalAlign": "bottom",  "textAlign": "right", "width": "30px" }}><img src={factory} /></td>
          <td style={{ padding: "0 3px", textAlign: "left"}}>
            <div style={{ position: "relative", marginBottom: "30px"}}>
              <div style={{ position: "absolute", display: progressBarElementsDisplay, height: "100%", width: xDockProgressAtPercent,  backgroundColor: "#fff",
                            textAlign: "right", marginBottom: "4px", cursor:"pointer"
                          }}>
                <img style={{width: "31px"}} src={xdockImage} title={xDockToolTip} />
              </div> 
              <div style={{ position: "absolute", display: progressBarMOTElementDisplay, height: "100%", width: progressPercent,  backgroundColor: "#fff",
                            textAlign: "right", marginBottom: "4px", cursor:"pointer", zIndex: "-1", top: "8px"
                          }}>
                <span title={lastCarrier}>{legNo}</span>
              </div>
            </div>
          </td>
          <td rowSpan="2" style={{ "verticalAlign": "bottom", "textAlign": "left","width": "30px" }}><img src={House} /></td>
        </tr>

//     <td style={{ "verticalAlign": "bottom", "width": "30px" }}      ><img src={xdockImage} title={('crossDockImage')} /></td>
        var logisticTimeline =
          <table className="logisticTimeline" border="0">
            <tbody>
              <tr className="ltTopDates">
                <td colSpan="1" style={{ "textAlign": "right", verticalAlign: "bottom", minWidth:"13ex" }}>{packListImg} {fmDate(row.shipped_at)}</td>
                <td colSpan="1" style={{ padding: "0 5px", 
                             verticalAlign: "bottom",
                             color: "#0096d6",
                             textAlign: "left"
                          }}>
                     <div style={{ display: eventDateDisplay, height: "100%", width: progressPercent,  backgroundColor: "#fff",
                                   textAlign: "right", marginBottom: "2px"
                                }}>
                       {latestCarrierEventDate}
                     </div>
                </td>
                <td colSpan="1" style={{ "textAlign": "left", minWidth:"14ex" }} nowrap="true">{DDateLabel}<br/>{DDateValue}</td>
              </tr>

              {legIcon}

              <tr className="ltProgress">
                <td colSpan="1" style={{ padding: "0 3px", "verticalAlign": "bottom" }}>
                   <div style={{ height: "12px", 
                                 backgroundColor: "#e8e8e8", 
                                 position: "relative",
                                 borderRadius: "0 6px 6px 0", 
                                 marginBottom:"2px" 
                   }}>
                     <div className={ progress > 98 ? "shipmentProgressBarArrow100" : "shipmentProgressBarArrow"}></div>
                     <div style={{ height: "100%", width: progressPercent,  borderRadius: "0 6px 6px 0",backgroundColor: "#0096d6"}}>
                     </div>
                   </div>
                </td>
              </tr>

              <tr className="ltLocations">
                <td style={{ textAlign: "right", 
                             minWidth:"13ex", 
                             verticalAlign: "top" ,
                             fontSize: "8pt"
                          }}>
                    {row.depotcity}, {row.depotcountry}
                 </td>
                <td colSpan="1" style={{ padding: "0 8px", verticalAlign: "top", textAlign: "left"}}>
                     <div style={{ display: progressBarElementsDisplay, 
                                   height: "100%", 
                                   width: progressPercent,  
                                   textAlign: "right", 
                                   marginBottom: "2px",
                                   color: "#0096d6",
                                   fontSize: "8pt" 
                                }}>
                       { showLatestCarrier &&
                         ( row.loc_country != "" 
                           ? <span>{lastCarrier},<br/>{row.loc_country}</span>
                           : lastCarrier
                         )
                       }  
                     </div>
                </td>
                <td style={{ textAlign: "left", 
                             verticalAlign: "top", 
                             minWidth:"14ex" ,
                             fontSize: "8pt"
                          }}>
                    {ShipAddr}
                </td>
              </tr>

            </tbody>
          </table>

      } else {

        /* ---- single leg ---- */
        
        var logisticTimeline =
          <table className="logisticTimeline" border="0">
            <tbody>
              <tr className="ltTopDates">
                <td colSpan="1" style={{ "textAlign": "right", verticalAlign: "bottom", minWidth:"13ex" }}>{packListImg} {fmDate(row.shipped_at)}</td>
                <td style={{ padding: "0 5px", 
                             verticalAlign: "bottom",
                             color: "#0096d6",
                             textAlign: "left"
                          }}>
                     <div style={{ display: eventDateDisplay, height: "100%", width: progressPercent,  backgroundColor: "#fff",
                                   textAlign: "right", marginBottom: "2px"
                                }}>
                       {latestCarrierEventDate}
                     </div>
                </td>
                <td colSpan="1" style={{ "textAlign": "left", minWidth:"14ex" }} nowrap="true">{DDateLabel}<br/>{DDateValue}</td>
              </tr>
              <tr className="ltIcons">
                <td rowSpan="2" style={{ "verticalAlign": "bottom",  "textAlign": "right", "width": "30px" }}><img src={factory} /></td>
                <td style={{ padding: "0 3px", textAlign: "left"}}>
                     <div style={{ display: progressBarElementsDisplay, height: "100%", width: progressPercent,  backgroundColor: "#fff",
                                   textAlign: "right", marginBottom: "4px", cursor:"pointer"
                                }}>
                      <span title={lastCarrier}>{leg1shippingType}</span>
                     </div>
                 </td>
                <td rowSpan="2" style={{ "verticalAlign": "bottom", "textAlign": "left","width": "30px" }}><img src={House} /></td>
              </tr>
              <tr className="ltProgress">
                <td style={{ padding: "0 3px", "verticalAlign": "bottom" }}>
                   <div style={{ height: "12px", 
                                 backgroundColor: "#e8e8e8", 
                                 position: "relative",
                                 borderRadius: "0 6px 6px 0", 
                                 marginBottom:"2px" 
                   }}>
                     <div className={ progress > 98 ? "shipmentProgressBarArrow100" : "shipmentProgressBarArrow"}></div>
                     <div style={{ height: "100%", width: progressPercent,  borderRadius: "0 6px 6px 0",backgroundColor: "#0096d6"}}>
                     </div>
                   </div>
                </td>
              </tr>
              <tr className="ltLocations">
                <td style={{ textAlign: "right", 
                             minWidth:"13ex", 
                             verticalAlign: "top" ,
                             fontSize: "8pt"
                          }}>
                    {row.depotcity}, {row.depotcountry}
                 </td>
                <td style={{ padding: "0 8px", verticalAlign: "top", textAlign: "left"}}>
                     <div style={{ display: progressBarElementsDisplay, 
                                   height: "100%", 
                                   width: progressPercent,  
                                   textAlign: "right", 
                                   marginBottom: "2px",
                                   color: "#0096d6",
                                   fontSize: "8pt" 
                                }}>
                       { showLatestCarrier &&
                         ( row.loc_country != "" 
                           ? <span>{lastCarrier},<br/>{row.loc_country}</span>
                           : lastCarrier
                         )
                       }  
                     </div>
                </td>
                <td style={{ textAlign: "left", 
                             verticalAlign: "top", 
                             minWidth:"14ex" ,
                             fontSize: "8pt"
                          }}>
                    {ShipAddr}
                </td>
              </tr>

            </tbody>
          </table>
      }
      
      return (
        <table key={i} className="logisticTimelineWrapper">
          <tbody>
            <tr>
              <td colSpan="3">
                <table>
                  <tbody>
                    <tr>
                      <th style={{ "textAlign": "center", "whiteSpace": "nowrap" }}>Tracking Number: {tNTButton}</th>
                      <th style={{ "textAlign": "center", "whiteSpace": "nowrap" }}>Shipment: {row.shipmentno}</th>
                      {routeInformations}
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td colSpan="3" style={{ "width": "100%", "padding": "10px 4px", "border": "1px solid #999999", "borderBottom": "0px" }}>{logisticTimeline}</td>
            </tr>
            <tr>
              <td colSpan="2" style={{ "width": "100%", "padding": "10px 4px", "border": "1px solid #999999", "borderRight": "0px", "borderTop": "0px", "borderBottom": "0px", "textAlign": "left" }}>
                <span style={{"color": "#0096d6", "fontSize": "17px" }}>{carrierEventDescr}</span>
              </td>
              <td colSpan="1" style={{ "width": "100%", "padding": "10px 4px", "border": "1px solid #999999", "borderLeft": "0px", "borderTop": "0px", "borderBottom": "0px" }}>
                {trackYourShipmentBtn}
              </td>
            </tr>
            <tr>
              <td colSpan="3" style={{ "width": "100%", "padding": "10px 4px", "border": "1px solid #999999", "borderTop": "0px" }}>
                <ToggleTable columns={row} callerArea={callerArea}/>
              </td>
            </tr>
          </tbody>
        </table>
      )
    });
 
    var over_flow = "auto";

    if (callerArea != "osv") {
        over_flow = "initial";
    }

    return (
      <div ref={this.tblRef} className="shipments-tracker" style={{"minHeight": "210px", overflow: over_flow }}>
        {shipments}
      </div>
    );
  }
};

function ShpTypeIcon(shipping_type, shipment_cancelled) {

  if ( !shipment_cancelled ) {

    if (shipping_type.toLowerCase() === "train") return <img src={train_icon_trans} />;
    if (shipping_type.toLowerCase() === "rail") return <img src={train_icon_trans} />;
    if (shipping_type.toLowerCase() === "airplane") return <img src={airplane_trans} />;
    if (shipping_type.toLowerCase() === "air") return <img src={airplane_trans} />;
    if (shipping_type.toLowerCase() === "vessel") return <img src={vessel_trans} />;
    if (shipping_type.toLowerCase() === "sea") return <img src={vessel_trans} />;
    if (shipping_type.toLowerCase() === "ocean") return <img src={vessel_trans} />;
    if (shipping_type.toLowerCase() === "ship/air") return <img src={vessel_trans} />;
    if (shipping_type.toLowerCase() === "a0") return <img src={airplane_trans} />;
    if (shipping_type.toLowerCase() === "a1") return <img src={airplane_trans} />;
    if (shipping_type.toLowerCase() === "m") return <img src={Truck_Veneer} height="27" style={{filter: cssBlue}} />;
    // M->Truck mapping after discussion with Titus and Oliver, this is for seen for VISTA orders
    return <img height="27" src={Truck_Veneer} style={{filter: cssBlue}} />;

  } else {

    if (shipping_type.toLowerCase() === "train") return <img src={train_icon_grey} />;
    if (shipping_type.toLowerCase() === "rail") return <img src={train_icon_grey} />;
    if (shipping_type.toLowerCase() === "airplane") return <img src={airplane_grey} />;
    if (shipping_type.toLowerCase() === "air") return <img src={airplane_grey} />;
    if (shipping_type.toLowerCase() === "vessel") return <img src={vessel_grey} />;
    if (shipping_type.toLowerCase() === "sea") return <img src={vessel_grey} />;
    if (shipping_type.toLowerCase() === "ocean") return <img src={vessel_grey} />;
    if (shipping_type.toLowerCase() === "ship/air") return <img src={vessel_grey} />;
    if (shipping_type.toLowerCase() === "a0") return <img src={airplane_grey} />;
    if (shipping_type.toLowerCase() === "a1") return <img src={airplane_grey} />;
    if (shipping_type.toLowerCase() === "m") return <img src={Truck_Veneer} height="27" style={{filter: cssGray}} />;
    // M->Truck mapping after discussion with Titus and Oliver, this is for seen for VISTA orders
    return <img height="27" src={Truck_Veneer} style={{filter: cssGray}} />;
  }
}

